import React, { Component } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import Modal from "react-modal";

import ListarUsuarios from "./listaUsuarios";


Modal.setAppElement(document.getElementById("root"));
const customStyles = {
  content: {
    top: "50%",
    left: "80%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "scroll"
  }
};

class ButtonVerUsuarios extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      idArt: 0,
      eddit: this.props.eddit,
      saved: 0
    };
  }
  closeModal() {
    this.openModal();
  }
  reload() {
    this.props.reload();
  }

  render() {
    return (
      <>

        <button
          className="btn btn-sm btn-info bg-gradient-info m-1"
          onClick={this.openModal.bind(this)}
        >
          <i className="fas fa-users"></i> Ver Usuarios Agregados
        </button>
        {
          <Modal
            isOpen={this.state.openModal}
            style={customStyles.content}
            contentLabel="Pase de Lista"
          >
            <div className="modal-header">
              {/* <h4 className="modal-title text-center">Usuarios en el Evento</h4> */}
              <button
                type="button"
                className="close"
                onClick={this.openModal.bind(this)}
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body card-primary card-outline card-outline-tabs">
              <div className="card-body">
              <ListarUsuarios 
                datos={this.props.datos}
                closeModal={this.closeModal.bind(this)}
              />
              </div>
            </div>
          </Modal>
        }
      </>
    );
  }
  openModal() {
    this.setState({
      openModal: !this.state.openModal
    });
  }
}
export default ButtonVerUsuarios;
